import { render, staticRenderFns } from "./AMAZON.vue?vue&type=template&id=d6413042&scoped=true"
import script from "./AMAZON.vue?vue&type=script&lang=js"
export * from "./AMAZON.vue?vue&type=script&lang=js"
import style0 from "./AMAZON.vue?vue&type=style&index=0&id=d6413042&prod&lang=css"
import style1 from "../index.css?vue&type=style&index=1&id=d6413042&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_cache-loader@4.1.0_webpack@4.47.0_supports-_afcd48d4a41aa41dd7c763bb85ff8663/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6413042",
  null
  
)

export default component.exports